<template>
  <div>
    <rl :rd="routerData"></rl>
    <div class="video-list container">
      <div class="flexbox" v-for="(item, index) of actionData" :key="index">
        <div class="showbox">
          <div class="rel">
            <div class="square"></div>
            <div class="abs">
              <router-link  :to="{name:'idetail',params:{id:item.id}}" tag="a">
                <div class=""><img class="max" :src="item.images[0]['url']" /></div>
              <h3><img class="titleImg" src="../../assets/img/title.png" /> {{ item.title }}</h3></router-link>
              <router-link  :to="{name:'idetail',params:{id:item.id}}" tag="p">
                {{ item.content }}
              </router-link>
              <!-- <div class="time"><img src="../../assets/img/time.png" /><div><span>发布时间：</span>{{ (item.create_time) | formatDate }}</div></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page">
      <Page :total="page.total" :page-size="get.ps" :current="get.pi" @on-change="pageChange($event)" />
    </div>
  </div>
</template>

<script>
import routerLink from "../public/routerlink.vue";
export default {
  name: "app",
  components: {
    'rl':routerLink,
  },
   filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        // let h = date.getHours();
        // h = h < 10 ? ('0' + h) : h;
        // let m = date.getMinutes();
        // m = m < 10 ? ('0' + m) : m;
        // let s = date.getSeconds();
        // s = s < 10 ? ('0' + s) : s;
          return y + '-' + MM + '-' + d ;
        //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
  data() {
    return {
      routerData: [{ title: "精彩图集", link: "image" }],
      actionData: [],
      page: {
        total: 0
      },
      get: {
        pi: parseInt(this.$route.params.p)?parseInt(this.$route.params.p):1,
        ps: 10,
        name: "fashion"
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    pageChange($event) {
      this.get.pi = $event;
      this.$router.push({name:'image',params:{p:$event}});
    //  this.getData();
    },
    getData() {
      this.$http.get("/Index/index/lists", { params: this.get }).then(res => {
        this.page.total = res.total;
        this.actionData = res.datas;
            window.scrollTo(0, 0); 
      });
    }
  }
};
</script>
<style lang="less" scoped>
.max{
  width: 100%;
}
.page {
  margin: 10px auto;
  text-align: center;
}
.video-list {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  // justify-content: space-between;
   padding: 0;
}
h3 {
  font-size: 20px;
  font-weight: 500;
  color: rgba(124, 124, 124, 1);
  opacity: 1;
  padding-bottom: 10px;
  margin:10px 0 ;
  display: flex;
  align-items: top;
  border-bottom: 1px dotted #bfbfbf;
  line-height: 28px;
  span {
    flex: 1 0 24px;
  }
}
.titleImg {
  // margin-right: 20px;
  width: 12px;
  height: 12px;
    margin:8px 10px 0 0 ;
}
.flexbox {
  overflow: hidden;
  box-sizing: border-box;
  width: 33.33%;
  padding: 10px;
  flex-flow: column;
  align-items: stretch;
  .showbox {
    height: 100%;
    position: relative;
    padding-bottom: 30px;
    .rel {
      position: relative;
    }
    .square {
      width: 100%;
      height: 0;
      padding-bottom: 100%;
    }
    .abs {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;

      p {
        margin-top: 10px;
      }
    }
    border: 4px solid #bfbfbf;
    box-sizing: border-box;
    padding: 30px;
    &:hover {
      border: 4px solid #ef504f;
    }
  }
}

div.time {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: right;
  // display: flex;
  // justify-content: space-between;
  // align-items: top;
  left: 0;
  padding: 0 30px;
  bottom: 10px;
  img {
    height: 12px;
    margin:-2px 10px 0 0;
    width: 12px;
  }
}

@media (min-width: 1200px) {
}

@media (max-width: 1199px) {
 
  .flexbox {
    width: 50%;
    padding: 20px;
    .showbox {
      box-sizing: border-box;
      padding: 30px;
    }
  }
}
@media (max-width: 750px) {
  .titleImg {
    width: 12px;
    height: 12px;
    margin:4px 5px 0 0;
  }
  div.time {
    // position: relative;
    bottom: 10px;
    font-size: 10px;
    padding: 0 10px;
    white-space: nowrap;
    margin-top: 10px;
    span {
      display: none;
    }
  }
  .flexbox {
    padding: 5px;
    .showbox {
      height: 100%;
      padding: 10px;
      padding-bottom: 40px;
      align-content: stretch;
      .square {
        padding-bottom: 0;
      }
      .abs {
        height: 100%;
        position: relative;
        p {
          font-size: 10px;
        }
      }
    }
  }
  h3 {
    font-size: 12px;
    line-height: 18px;
    padding-bottom: 10px;
    img {
      margin:-2px 8px 0 0;
    }
  }
}
</style>